import React, { useEffect } from 'react';
import { withLoading } from '@adjust/dashboard-components';
import { Account } from '@adjust/dashboard-core/api/types';
import { hasNewFeatureScope } from '@adjust/dashboard-core/lib/utils/account';

import { gettext } from '@adjust/dashboard-core/lib/utils/localization';
import { CurrentCharge, Invoice, InvoiceType } from '@api/types';
import { InvoiceDetails } from './InvoiceDetails';
import { InvoicePageError } from './InvoicePageError';

import './InvoicesPage.scss';

const invoiceTypeMap = {
  [InvoiceType.Regular]: gettext('invoice.type.regular'),
  [InvoiceType.PrePayment]: gettext('invoice.type.regular'), // Regular and prepayment invoices don't have differences in UI
  [InvoiceType.CreditNote]: gettext('invoice.type.credit-note'),
};

export interface InvoicesPageStateProps {
  currentAccount: Nullable<Account>;
  invoices: Invoice[] | null;
  currentCharge: CurrentCharge | null;
  isLoading: boolean;
  isError: boolean;
}

export interface InvoicesPageDispatchProps {
  fetchData: () => void;
}

type InvoicesPageProps = InvoicesPageStateProps & InvoicesPageDispatchProps;

const InvoicesPage: React.FC<InvoicesPageProps> = ({ currentAccount, currentCharge, isError, invoices, fetchData }) => {
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isError) {
    return <InvoicePageError />;
  }

  const isNewBilling = currentAccount?.new_billing || false;

  return (
    <div className="content flex-one flex-box-column invoices">
      <div className="summary">
        <h3>{t('label.billing-details')}</h3>
      </div>

      <ul className="invoices-container">
        {currentCharge && !hasNewFeatureScope(currentAccount) && !isNewBilling ? (
          <InvoiceDetails
            totalAttributions={currentCharge.totalAttributions}
            totalPriceNet={currentCharge.totalPriceNet}
            billingPeriodStart={currentCharge.begin}
            billingPeriodEnd={currentCharge.end}
            typeLabel={t('invoice.type.current')}
          />
        ) : null}

        {invoices?.map(invoice => (
          <InvoiceDetails {...invoice} key={invoice.number} typeLabel={t(invoiceTypeMap[invoice.invoiceType])} />
        ))}
      </ul>
    </div>
  );
};

export const InvoicesPageWithLoading = withLoading(InvoicesPage, true);
